"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.models.source': 'Sorgente IA',
};
